var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-[#2E2E2E]",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.237a.583.583 0 0 0-.583.583v1.167H10.5V1.82a.583.583 0 1 0-1.166 0v.583H4.667V1.82a.583.583 0 0 0-1.167 0v1.167H2.334V1.82a.583.583 0 0 0-1.167 0v10.5a.583.583 0 1 0 1.167 0v-1.167H3.5v1.167a.583.583 0 1 0 1.167 0v-.583h4.667v.583a.583.583 0 1 0 1.166 0v-1.167h1.167v1.167a.583.583 0 1 0 1.167 0V1.82a.583.583 0 0 0-.584-.583zM3.5 9.987H2.334V8.82H3.5v1.167zm0-2.334H2.334V6.487H3.5v1.166zm0-2.333H2.334V4.153H3.5V5.32zm5.834 5.25H4.667V7.653h4.667v2.917zm0-4.083H4.667V3.57h4.667v2.917zm2.333 3.5H10.5V8.82h1.167v1.167zm0-2.334H10.5V6.487h1.167v1.166zm0-2.333H10.5V4.153h1.167V5.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.aa49a9221ef564649ee7231bfd9118bf.svg";
export { ForwardRef as ReactComponent };